import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router';

export default function BackArrowButton(){
  const navigate = useNavigate();

  return (
    <Tooltip title="Back">
      <IconButton onClick={() => navigate(-1)}>
        <ArrowBackIosIcon />
      </IconButton>
    </Tooltip>
  );
};

